import { parsePermissionError } from "./permissionMessages";

/**
 * Tüm "yetki yok" uyarıları PermissionAlertProvider içindeki Snackbar ile gösterilir.
 * Axios dışından (veya hook kullanmadan) aynı bileşeni tetiklemek için bu fonksiyonu kullanın.
 */
/**
 * @param {string|object|null|undefined} input — string (legacy) veya backend { errorCode, requiredPermission, message }
 */
export function emitPermissionError(input) {
  const message = parsePermissionError(input);
  window.dispatchEvent(
    new CustomEvent("permissionError", { detail: { message } })
  );
}

/** Axios yanıt gövdesi: önce `errorCode`, yoksa `message` / `error` (legacy metin). */
export function emitPermissionErrorFromResponseData(data) {
  if (data == null) {
    emitPermissionError("");
    return;
  }
  if (typeof data === "string") {
    emitPermissionError(data);
    return;
  }
  emitPermissionError(data);
}

/**
 * Doktor/tenant axios interceptor: 403 için merkezi uyarı.
 * `config.skipGlobalPermissionAlert === true` ise (ör. çift uyarı önleme) atlanır.
 */
export function maybeEmitPermissionErrorFromAxios403(error) {
  if (!error?.response || error.response.status !== 403) return;
  if (error.config?.skipGlobalPermissionAlert) return;
  emitPermissionErrorFromResponseData(error.response.data);
}
